import implyVariantFromSelections from "./implyVariantFromSelections";

const getIndicativeDiscount = ({
  selectedColourWayId,
  selectedVariantId,
  variants
}) => {
  const { discount } = implyVariantFromSelections({
    selectedColourWayId,
    selectedVariantId,
    variants
  });

  return discount;
};

export default getIndicativeDiscount;
